var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailRed = function SvgEmailRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1543",
    d: "M21.25 4.75H22a.75.75 0 0 0-.75-.75zm0 14.5V20a.75.75 0 0 0 .75-.75zm-18.5 0H2c0 .414.336.75.75.75zm0-14.5V4a.75.75 0 0 0-.75.75zM12 13l-.475.58a.75.75 0 0 0 .95 0zm9.25-8.25h-.75v14.5H22V4.75zm0 14.5v-.75H2.75V20h18.5zm-18.5 0h.75V4.75H2v14.5zm0-14.5v.75h18.5V4H2.75zM12 13l.475-.58-9-7.364-.475.58-.475.58 9 7.365zm9-7.364-.475-.58-9 7.363L12 13l.475.58 9-7.363z"
  })));
};
export default SvgEmailRed;